import {MCM} from "../../util/Constants";

export const GlobalStateReducer = (state, action) => {
  switch (action.type) {
    case 'RESTART_APP':
      return { ...state, resetID: Math.random(), asyncError: '' };
    case 'SET_ASYNC_ERROR':
      return { ...state, asyncError: action.data.asyncError };
    case 'SET_WARNING':
      return { ...state, warningMsg: action.data.warningMsg, warningAction : action.data.warningAction };
    case 'SHOW_CUSTOM_ALERT':
      return {...state, toasts: [...state.toasts, action.data.toast]}
    case 'CLOSE_CUSTOM_ALERT':
      return {...state, toasts: state.toasts.filter((toast) => toast.id !== action.data.toastId)}
    case 'SET_LINK':
      return {...state, link: action.data.link}
    case 'SET_LINK_TAB':
      return {...state, linkTab: action.data.linkTab}
    case 'SET_LOADING_FEATURES':
      return {...state, loadingFeatures: action.data.loadingFeatures}
    default:
      return state;
  }
};

export const initialState = {
  asyncError: '',
  resetID: Math.random(),
  warningMsg: '',
  warningAction: () => {},
  toasts: [],
  link: "",
  linkTab: MCM,
  loadingFeatures: false,
};



// WEBPACK FOOTER //
// ./src/components/global/reducers/GlobalStateReducer.js